import { useTranslation } from "react-i18next";
import { useState } from "react";
import { OptionsPaymentTermModal } from "./optionsPaymentTermModal";
import { CalendarDays } from "lucide-react";

type OptionsPaymentTermProps = {
  defaultPaymentTerm: number;
};

export const OptionsPaymentTerm = ({ defaultPaymentTerm }: OptionsPaymentTermProps) => {
  const { t } = useTranslation("boParameters");
  const [showPaymentTermModal, setShowPaymentTermModal] = useState<boolean>(false);

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex w-fit flex-row items-center gap-4">
          <CalendarDays className="text-black" width={24} height={24} />
          <div className="flex flex-1 flex-col">
            <h3 className="text-lg font-semibold text-black">{t("paymentTermOption.title")}</h3>
          </div>
        </div>
        <div className="flex flex-row items-center gap-4">
          <button
            type="button"
            onClick={() => setShowPaymentTermModal(true)}
            className="bg-brand50 text-brand700 h-fit w-fit rounded-lg px-4 py-2 text-sm font-semibold hover:bg-blue-100 focus:outline-hidden"
          >
            {t("paymentTermOption.edit")}
          </button>
        </div>
      </div>
      <div className="flex flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p className="text-xs font-medium text-gray-500">{t("paymentTermOption.termLabel")}</p>
        <p className="text-sm font-medium text-gray-900">
          {t("paymentTermOption.daysValue", { count: defaultPaymentTerm })}
        </p>
      </div>
      {showPaymentTermModal && (
        <OptionsPaymentTermModal
          closeModal={() => setShowPaymentTermModal(false)}
          title={t("paymentTermOption.modalTitle")}
          defaultPaymentTerm={defaultPaymentTerm}
        />
      )}
    </div>
  );
};
